import axios from "axios";

const PostsAPI = {

    async getAllPosts() {
        let pld = (await axios.get(`/posts/all`)).data;
        return pld;
    },

    async getUserPosts(userId) {
        let pld = (await axios.get(`/users/${userId}/posts`)).data;
        return pld;
    },

    async getPost(id) {
        let pld = (await axios.get(`/posts/${id}`)).data;
        return pld;
    },

    async createPost(data = {}) {
        let pld = (await axios.post(`/posts`, data)).data;
        return pld;
    },

    async updatePost(data = {}) {
        let pld = (await axios.put(`/posts`, data)).data;
        return pld;
    },

    async deletePost(id) {
        let pld = (await axios.delete(`/posts/${id}`)).data;
        return pld;
    }


};

export default PostsAPI;
